import dayjs from 'dayjs';

import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/it';
import 'dayjs/locale/es';
import 'dayjs/locale/pt';
import 'dayjs/locale/nl';
import 'dayjs/locale/da';
import 'dayjs/locale/sv';
import 'dayjs/locale/nb';

import { getPageLocale } from '../genericUtils/genericUtils';

dayjs.locale(getPageLocale());

export { dayjs };
